import { InvitingManagerType, SlotType, UsersInSlotType } from 'api';
import { AppRootStateType } from 'state/store';

export const slotsSelect = (state: AppRootStateType): SlotType => state.slots.slots;
export const certainSlotSelect = (state: AppRootStateType): UsersInSlotType | undefined =>
  state.slots.certainSlot;
export const invitingManagersSelect = (state: AppRootStateType): InvitingManagerType[] =>
  state.slots.invitingManagers;
